export default __webpack_public_path__ + "static/languages-e9f098576f41a948e46f31f05ed1a3c0.svg";